import { push } from 'modules/gtm/modules/common';
import { GTMProductParsed } from 'modules/gtm/modules/types';

export const gtmPushItemListView = (data: {
  currency: string;
  items: GTMProductParsed[];
}) =>
  push({
    event: 'Ecommerce - Item List Views',
    event_name: 'view_item_list',
    view_item_list: {
      currency: data.currency,
      items: data.items,
    },
  });
